/**
 *
 * File: ProjectsRequest.js
 *
 */
(function () {
    angular
        .module('maApp.remoteRequests')
        .factory('ProjectsRequest', ProjectsRequest);
    ProjectsRequest.$inject = ['$http', '$interpolate', 'endpoint', 'Auth', 'RequestError'];
    function ProjectsRequest($http, $interpolate, endpoint, Auth, RequestError) {
        return {
            'get':fetchProjects
        };

        function fetchProjects() {
            return $http({
                method:'GET',
                url:$interpolate('{{ep}}projects/?dataonly=1&{{ap}}')({ep:endpoint, ap:Auth.getUserAuthQueryStr()}),
                cache:true
            })
                .then(fetchSuccess, fetchFail);

            function fetchSuccess(response) {
                //TODO: Have the api only send projects that can handle management action schema
                return response.data;
            }

            function fetchFail(response){
                throw new RequestError(response, 'Failed to read projects');
            }
        }
    }
})();